export default function TasksTextsView({item, add, edit='', deleteI, textTitle, text}) {
  return (
    <div className="test-creator-question">      
      <div className="test-creator__question"> 
        <div className="question-buttons-container">
          <span className="test-creator-addbutton" onClick={(e) => add(item)}>+</span>
          { item.is_editable && edit && <span className="test-creator-changebutton" onClick={() => edit(item.id)}>&#x270e;</span>}
          {item.is_deletable &&  <span className="test-creator-deletebutton" onClick={() => deleteI(item)}>x</span>}
        </div>
          <span style={{display: 'flex', fontSize: '16px', alignItems: 'baseline'}}><span style={{marginRight: '20px', fontSize: '19px'}}> { textTitle } </span> {text}</span>
        </div>
    </div>
  )
}